export const NAMESPACE = 'form-templates';
